import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const CookieConsent = () => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const consent = localStorage.getItem('cookieConsent');
        if (!consent) {
            setIsVisible(true);
        }
    }, []);

    const handleAccept = () => {
        localStorage.setItem('cookieConsent', 'true');
        setIsVisible(false);
    };

    if (!isVisible) return null;

    return (
        <div className="fixed bottom-0 left-0 right-0 z-[100] p-4 animate-fade-in-up">
            <div className="max-w-4xl mx-auto bg-white border border-gray-100 shadow-2xl rounded-2xl p-6 md:p-8 flex flex-col md:flex-row items-center justify-between gap-6 overflow-hidden relative">
                {/* Decorative background element */}
                <div className="absolute top-0 left-0 w-2 h-full bg-gradient-to-b from-purple-600 to-pink-500"></div>

                <div className="flex-1">
                    <h3 className="text-xl font-bold text-gray-800 mb-2 flex items-center gap-2">
                        <span className="text-2xl">🍪</span> Slapukų naudojimas
                    </h3>
                    <p className="text-gray-600 text-sm leading-relaxed">
                        Savo svetainėje naudojame slapukus, kad užtikrintume geriausią jūsų patirtį, analizuotume srautą ir pritaikytume AI turinį. 
                        Daugiau informacijos rasite mūsų <Link to="/privatumas" className="text-purple-600 hover:underline font-medium">Privatumo politikoje</Link>.
                    </p>
                </div>

                <div className="flex gap-3 w-full md:w-auto shrink-0">
                    <button 
                        onClick={handleAccept}
                        className="flex-1 md:flex-none px-8 py-3 bg-gradient-to-r from-purple-600 to-pink-500 text-white rounded-xl font-bold hover:shadow-lg transition transform hover:scale-[1.05]"
                    >
                        Sutinku ✅
                    </button>
                    <Link 
                        to="/taisykles"
                        className="flex-1 md:flex-none px-8 py-3 bg-gray-100 text-gray-700 rounded-xl font-bold hover:bg-gray-200 transition text-center"
                    >
                        Daugiau
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default CookieConsent;
